import ParameterErrors from '../errors/ParameterErrors';
const {throwNotOfType, throwNotProvided} = ParameterErrors;
export default class AvailablePricesSettings {
	constructor(props){
		const {desiredIntervalsPrice}=props;
		if(desiredIntervalsPrice !== undefined && desiredIntervalsPrice !==null)
		if(!Array.isArray(desiredIntervalsPrice))
			throwNotOfType('desiredIntervalsPrice', 'Array');
		for(var i=0; i<desiredIntervalsPrice.length; i++){
			if(typeof(desiredIntervalsPrice[i].from)!=='number')
				throwNotOfType(`desiredIntervalsPrice[${i}].from`, 'number');
			if(typeof(desiredIntervalsPrice[i].to)!=='number')
				throwNotOfType(`desiredIntervalsPrice[${i}].to`, 'number');
		}
		this._desiredIntervalsPrice = desiredIntervalsPrice;
	}	
	get desiredIntervalsPrice(){
		return this._desiredIntervalsPrice;
	}
	static fromJSON(jObject){
		return new AvailablePricesSettings({
				desiredIntervalsPrice:jObject.desiredIntervalsPrice
		});
	}
}
